import { checkMax, i18, trb } from '../../Utilities';
import { FormField, FormFieldType } from '../FormField';
import { Number } from '../Number';

interface IProps {
  data: {
    InstantOperationMSignLimit: number;
    InstantOperationSmsLimit: number;
    InstantOperationMSignLimitMax: number;
    InstantOperationSmsLimitMax: number;
  };
  isEditMode: boolean;
  isDisabled: boolean;
}

export const AccountsLimitsInstant = ({ data, isEditMode, isDisabled }: IProps) => {
  return (
    <div className="eb_table">
      <div className="row eb_table_head d-none d-md-flex text-break">
        <div className="col-12 col-md-6 px-1">{trb(i18.Labels.InstantLimitESign)}</div>
        <div className="col-12 col-md-6 px-1 text-left">{trb(i18.Labels.InstantLimitSMS)}</div>
      </div>
      <div className="row eb_table_row">
        <div className="col-12 col-md-6 px-1">
          <div className="d-block d-md-none text-black-50">{trb(i18.Labels.InstantLimitESign)}</div>
          {isEditMode ? (
            <FormField
              validate={checkMax(data?.InstantOperationMSignLimitMax)}
              name={`InstantOperationMSignLimit`}
              component={FormFieldType.number}
              disabled={isDisabled}
            />
          ) : !!data?.InstantOperationMSignLimit ? (
            <Number value={data?.InstantOperationMSignLimit} />
          ) : (
            trb(i18.Labels.InstantLimitNotSet)
          )}
        </div>
        <div className="col-12 col-md-6 px-1">
          <div className="d-block d-md-none text-black-50">{trb(i18.Labels.InstantLimitSMS)}</div>
          {isEditMode ? (
            <FormField
              validate={checkMax(data?.InstantOperationSmsLimitMax)}
              name={`InstantOperationSmsLimit`}
              component={FormFieldType.number}
              disabled={isDisabled}
            />
          ) : !!data?.InstantOperationSmsLimit ? (
            <Number value={data?.InstantOperationSmsLimit} />
          ) : (
            trb(i18.Labels.InstantLimitNotSet)
          )}
        </div>
      </div>
    </div>
  );
};
